import { jsx, jsxs } from 'react/jsx-runtime';
import { Progress, WarningPanel } from '@backstage/core-components';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, useTheme } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';
import ReactJson from 'react-json-view';
import { useConfig } from '../../../hooks/useConfig.esm.js';
import '../../../api/DevToolsApi.esm.js';
import '@backstage/errors';
import '@backstage/core-plugin-api';
import 'react-use/esm/useAsync';

const useStyles = makeStyles(
  (theme) => createStyles({
    warningStyle: {
      paddingBottom: theme.spacing(2)
    },
    paperStyle: {
      padding: theme.spacing(2)
    }
  })
);
const WarningContent = ({ error }) => {
  if (!error.messages) {
    return /* @__PURE__ */ jsx(Typography, { children: error.message });
  }
  const messages = error.messages;
  return /* @__PURE__ */ jsx(Box, { children: messages.map((message) => /* @__PURE__ */ jsx(Typography, { children: message })) });
};
const ConfigContent = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { configInfo, loading, error } = useConfig();
  if (loading) {
    return /* @__PURE__ */ jsx(Progress, {});
  } else if (error) {
    return /* @__PURE__ */ jsx(Alert, { severity: "error", children: error.message });
  }
  if (!configInfo) {
    return /* @__PURE__ */ jsx(Alert, { severity: "error", children: "Unable to load config data" });
  }
  return /* @__PURE__ */ jsxs(Box, { children: [
    configInfo && configInfo.error && /* @__PURE__ */ jsx(Box, { className: classes.warningStyle, children: /* @__PURE__ */ jsx(WarningPanel, { title: "Config validation failed", children: /* @__PURE__ */ jsx(WarningContent, { error: configInfo.error }) }) }),
    /* @__PURE__ */ jsx(Paper, { className: classes.paperStyle, children: /* @__PURE__ */ jsx(
      ReactJson,
      {
        src: configInfo.config,
        name: "config",
        enableClipboard: false,
        theme: theme.palette.type === "dark" ? "chalk" : "rjv-default"
      }
    ) })
  ] });
};

export { ConfigContent, WarningContent };
//# sourceMappingURL=ConfigContent.esm.js.map
